__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "demandbase-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@demandbase/global-context", "0.0.1", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(632)]).then(() => (() => (__webpack_require__("./modules/global_context/src/index.js"))))));
			register("@reduxjs/toolkit", "2.0.0", () => (Promise.all([__webpack_require__.e(983), __webpack_require__.e(38), __webpack_require__.e(728)]).then(() => (() => (__webpack_require__("./node_modules/@reduxjs/toolkit/dist/redux-toolkit.modern.mjs"))))));
			register("launchdarkly-react-client-sdk", "3.4.0", () => (Promise.all([__webpack_require__.e(545), __webpack_require__.e(914), __webpack_require__.e(189)]).then(() => (() => (__webpack_require__("./node_modules/launchdarkly-react-client-sdk/lib/esm/index.js"))))));
			register("react-dom/client", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914), __webpack_require__.e(338)]).then(() => (() => (__webpack_require__("./node_modules/react-dom/client.js"))))));
			register("react-is", "16.13.1", () => (__webpack_require__.e(404).then(() => (() => (__webpack_require__("./node_modules/hoist-non-react-statics/node_modules/react-is/index.js"))))));
			register("react-is", "16.13.1", () => (__webpack_require__.e(564).then(() => (() => (__webpack_require__("./node_modules/react-router/node_modules/react-is/index.js"))))));
			register("react-is", "18.3.1", () => (__webpack_require__.e(363).then(() => (() => (__webpack_require__("./node_modules/react-is/index.js"))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(733), __webpack_require__.e(914), __webpack_require__.e(189), __webpack_require__.e(528), __webpack_require__.e(716)]).then(() => (() => (__webpack_require__("./node_modules/react-redux/es/index.js"))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(914), __webpack_require__.e(401), __webpack_require__.e(625)]).then(() => (() => (__webpack_require__("./node_modules/react-router-dom/esm/react-router-dom.js"))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(387), __webpack_require__.e(347), __webpack_require__.e(914), __webpack_require__.e(189), __webpack_require__.e(789)]).then(() => (() => (__webpack_require__("./node_modules/react-router/esm/react-router.js"))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__("./node_modules/react/index.js"))))));
			register("redux-saga", "1.3.0", () => (Promise.all([__webpack_require__.e(960), __webpack_require__.e(335)]).then(() => (() => (__webpack_require__("./node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js"))))));
			register("redux", "5.0.1", () => (__webpack_require__.e(644).then(() => (() => (__webpack_require__("./node_modules/redux/dist/redux.mjs"))))));
			initExternal("webpack/container/reference/@demandbase/app");
			initExternal("webpack/container/reference/@demandbase/common");
			initExternal("webpack/container/reference/@demandbase/sales");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};